import { render, staticRenderFns } from "./purchaseAccountTuibu.vue?vue&type=template&id=0b6e5443&scoped=true"
import script from "./purchaseAccountTuibu.vue?vue&type=script&lang=js"
export * from "./purchaseAccountTuibu.vue?vue&type=script&lang=js"
import style0 from "./purchaseAccountTuibu.vue?vue&type=style&index=0&id=0b6e5443&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6e5443",
  null
  
)

export default component.exports